import { useQuery } from "@tanstack/react-query";

import useAuth from "@readai/common/hooks/useAuth";

const useEnsureUser = () => {
  const { fetchAndSetUser, setUser } = useAuth();
  return useQuery({
    queryKey: ["user"],
    queryFn: async () => {
      try {
        return await fetchAndSetUser();
      } catch {
        setUser(null);
        return null;
      }
    },
  });
};

export default useEnsureUser;
